import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import AOS from 'aos';
import 'aos/dist/aos.css';

const app = createApp(App)

app.use(router)

// 初始化 AOS
app.mixin({
  mounted() {
    this.$nextTick(() => {
      AOS.init({
        duration: 800,
        once: true,
        easing: 'ease-out-cubic'
      });
    });
  }
});

app.mount('#app')